import {
    SearchScenarioId,
    getSuggestions,
    registerAdditionalQuickActions,
    searchSessionStarted,
    startSearch,
} from 'owa-search';
import {
    setAccountScope,
    setCalendarFoldersScope,
    setNonSearchableCalendarsText,
} from 'owa-calendar-search-store';

import { createLazyOrchestrator } from 'owa-bundling';
import getQuickActionsForSuggestion from '../utils/getQuickActionsForSuggestion';
import { lazyAddMasterCategories } from 'owa-categories';
import { setSearchActive } from 'owa-suite-header-apis';

/**
 * This is the calendar-specific startSearchSessionOrchestrator. It's responsible
 * for handling calendar-specific initialization.
 */
export const searchSessionStartedOrchestrator = createLazyOrchestrator(
    searchSessionStarted,
    'CLONE_CALENDAR_SEARCH_SESSION_STARTED',
    async actionMessage => {
        const { actionSource, shouldStartSearch, scenarioId } = actionMessage;

        if (scenarioId != SearchScenarioId.Calendar) {
            return;
        }
        // Loading the categories package early on to avoid
        // scrolling issue.
        lazyAddMasterCategories.import();

        // Initialize AccountScopePicker data
        setAccountScope(true /* initializeAccountScope */, null);

        // VSO 85371 If the account scope is set to a connected account, then we should also initialize the search query
        // for the connected account since that would not have been done by the SearchScopePicker

        // Initialize folder scope data (based on currently selected node).
        setCalendarFoldersScope(null);

        setNonSearchableCalendarsText(false);

        // Initialize the calendar-specific quick actions
        registerAdditionalQuickActions(SearchScenarioId.Calendar, getQuickActionsForSuggestion);

        // set the search state
        setSearchActive(true);

        if (shouldStartSearch) {
            startSearch(actionSource, SearchScenarioId.Calendar);
        } else {
            getSuggestions(SearchScenarioId.Calendar);
        }
    }
);
